/** @jsxImportSource @emotion/react */
import React, { useCallback } from 'react';
import type { DivProps } from 'typings';
import AppStoreIcon from 'ud-ui/components/icon/app-store-icon';
import GooglePlayIcon from 'ud-ui/components/icon/google-play-icon';
import * as S from './styles';

interface IStubLinksProps extends DivProps {}

function StubLinks(props: IStubLinksProps) {
  const { ...rest } = props;

  const onClickLink = useCallback((url: string) => {
    if (!url) return;
    // Открываем в новой вкладке безопасно
    window.open(url);
  }, []);

  return (
    <S.MainBlock {...rest}>
      <S.LinksTitle>Скачать приложение можно тут</S.LinksTitle>
      <S.LinksCardWrapper>
        <LinkCard
          title="App store"
          icon={<AppStoreIcon />}
          onClick={() => onClickLink('https://apps.apple.com/ru/app/imgameadmin/id1626473416')}
        />
        <LinkCard
          title="Google Play"
          icon={<GooglePlayIcon />}
          onClick={() => onClickLink('https://disk.yandex.ru/d/9N9LR1LnXzyt-g')}
        />
      </S.LinksCardWrapper>
    </S.MainBlock>
  );
}

export default StubLinks;

function LinkCard(props: { title: string; icon: React.ReactNode } & DivProps) {
  const { icon, title, ...rest } = props;

  return (
    <S.LinkCard {...rest}>
      {icon}
      <S.LinkCardText>{title}</S.LinkCardText>
    </S.LinkCard>
  );
}
